let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h74XT")).then(() => parcelRequire('6KYJl'));